<template>
  <section class="content">
    <b-row class="container">
      <b-col class="container" cols="12">
        <div class="searchandsort">
          <div class="search">
            <b-input-group>
              <b-form-input name="search" placeholder="Die Suche hat hier ein Ende"/>
              <b-input-group-append>
                <p class="h5 m-auto p-2">
                  <b-icon icon="search"></b-icon>
                </p>
              </b-input-group-append>
            </b-input-group>
          </div>

          <div class="sortbox">
            <div class="sort" v-on:click="showSort = !showSort">
              <b-icon icon="filter"></b-icon>
              <div class="dropdown-content" id="sort" v-if="showSort">
                <ul class="list">
                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="sort-alpha-down"></b-icon></span>
                      <span class="lefttext"> Alphabetisch </span>
                    </a>
                  </li>

                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="cash"></b-icon></span>
                      <span class="lefttext"> Preis </span>
                    </a>
                  </li>

                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="geo"></b-icon></span>
                      <span class="lefttext"> Entfernung </span>
                    </a>
                  </li>
                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="star"></b-icon></span>
                      <span class="lefttext"> Bewertung </span>
                    </a>
                  </li>
                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="calendar2-date"></b-icon></span>
                      <span class="lefttext"> Datum </span>
                    </a>
                  </li>
                  <li>
                    <a class="item" href="#">
                      <span class="lefticon"><b-icon icon="eye"></b-icon></span>
                      <span class="lefttext"> Status </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="container">
      <b-col cols="12" md="3">
        <div class="filterbox">
          <div class="card-filter">
            <div class="divder"><h5> Kategorien </h5></div>
            <div class="accordion" @click="showCategories = !showCategories"><span>Sportart wählen</span></div>
            <ul class="categories" id="categorieDisplay">
              <li v-for="(sport, indx) in sports" @click="selectSportFilter(sport.sportId)" :class="{ 'selected': filter.sportIdArray.indexOf(sport.sportId) >= 0}" :key="indx"><img :alt="sport.name" :src="sport.icon" />{{ sport.name }}</li>
            </ul>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Bewertung </h5></div>
            <div>
              <b-form-rating variant="success" v-model="filter.minRating"></b-form-rating>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Von </h5></div>
            <div>
              <b-form-datepicker locale="de" @input="getEvents" reset-button v-model="filter.fromDate" placeholder="Von..." class="mb-2"></b-form-datepicker>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Bis </h5></div>
            <div>
              <b-form-datepicker locale="de" @input="getEvents" reset-button v-model="filter.toDate" placeholder="Bis..." class="mb-2"></b-form-datepicker>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Maximale Distanz </h5></div>
            <div style="text-align: center">
              <b-form-input @input="getEvents" v-model="filter.maxDistance" type="range" step="0.5" min="0" max="50"></b-form-input>
              <span> {{filter.maxDistance }} km</span>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Minimaler preis </h5></div>
            <div style="text-align: center">
              <b-form-input @input="getEvents" v-model="filter.priceMin" type="range" step="0.5" min="0" max="40"></b-form-input>
              <span> {{filter.priceMin }} EUR</span>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Maximaler preis </h5></div>
            <div style="text-align: center">
              <b-form-input @input="getEvents" v-model="filter.priceMax" type="range" step="0.5" min="0" max="40"></b-form-input>
              <span> {{filter.priceMax }} EUR</span>
            </div>
          </div>
          <div class="card-filter">
            <div class="divder"><h5> Schwierigkeit </h5></div>
            <div class="difficulty">
              <a class="difficulybutton">
                <b-icon icon="type-h1"></b-icon>
              </a>
              <a class="difficulybutton">
                <b-icon icon="type-h2"></b-icon>
              </a>
              <a class="difficulybutton">
                <b-icon icon="type-h3"></b-icon>
              </a>
              <a class="difficulybutton">
                <b-icon icon="shield-lock"></b-icon>
              </a>
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="events" cols="12" md="9">

        <div :class="['event',event.isUserParticipant?'user-participant':'']" @click="displayEvent(event)" v-for="(event, index) in events" v-bind:key="event.id" v-bind:index="index">
          <div class="eventpic">
            <div class="picture">
              <a href="">
                <img :src="event.field.images[0]" alt="">
              </a>
            </div>
          </div>
          <div class="eventdetailshort" :key="rerendertrigger">
            <h5> {{ event.title }} <span>{{ getPrice(event) }}</span></h5>
            <h6> {{ formatDate(event) }}, {{ event.duration.time }} Min</h6>
            <h6>{{ event.field.city }} {{ event.field.plz }}, {{ event.field.address }}</h6>
            <h6><span :class="['align-left','no-margin', event.participants.current>=event.participants.min?'event-active':'']">{{ getFooterText(event) }}</span></h6>
            <h6><span class="align-left font-weight-bold">{{ getCurrentTimeLeft(event, rerendertrigger)}}</span><span class="align-right">Status: {{ event.state.name }}</span></h6>
          </div>
        </div>
        <div class="mt-3">
          <b-pagination size="lg" align="center" v-model="currentPage" :total-rows="rows" :per-page="limit"
                        @input="getEvents()"/>
        </div>
      </b-col>
    </b-row>
    <b-modal
        ref="eventview"
        id="single-event-view"
        title=""
        size="xl"
    >
        <div class="modalimportantinfos" v-if="selectedEvent">
          <div class="modalgallery">
            <b-carousel
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
            >
              <b-carousel-slide v-for="(img, index) in selectedEvent.field.images" v-bind:key="index" v-bind:index="index" :img-src="img"></b-carousel-slide>
            </b-carousel>
          </div>
          <div class="modalcontent">
            <h3>{{ formatDate(selectedEvent) }}, {{ selectedEvent.duration.time }} Min</h3>
            <h5>{{ selectedEvent.field.city }} {{ selectedEvent.field.plz }}, {{ selectedEvent.field.address }}</h5>
            <div class="modaltext">
              <b-form-rating class="modalformrating" icon-empty="heart" icon-full="heart-fill" icon-half="heart-half" value="3" variant="success" inline readonly></b-form-rating>
              <h5>Beschreibung</h5>
              <table class="modalul">
                <tr>
                  <td>
                    Öffentlich
                  </td>
                  <td>
                    <b-icon class="m-auto" icon="check" v-if="selectedEvent.public"></b-icon>
                    <b-icon class="m-auto" icon="x" v-else></b-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    Type
                  </td>
                  <td>
                  </td>
                </tr>
                <tr>
                  <td>
                    Status
                  </td>
                  <td>
                    {{ selectedEvent.state.name }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Max. Preis
                  </td>
                  <td>
                    {{ currencyFormatDE(selectedEvent.maxPricePerPerson.value) }} €
                  </td>
                </tr>
                <tr>
                  <td>
                    Distanz
                  </td>
                  <td>
                    {{ Math.round((selectedEvent.distance + Number.EPSILON) * 100) / 100 }} km
                  </td>
                </tr>
                <tr>
                  <td>
                    Sport
                  </td>
                  <td>
                    {{ selectedEvent.sportName }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Zeit
                  </td>
                  <td>
                    {{ formatDate(selectedEvent) }}
                  </td>
                </tr>
              </table>
              <b>Zusatz-Information</b>
              <p> {{ selectedEvent.description }}</p>

            </div>
            <div class="acceptplay">
              <b-button variant="primary" squared> Freunde einladen</b-button>
              <b-button v-if="selectedEvent.isUserParticipant" @click="unregisterFromEvent" squared variant="danger"> Abmelden</b-button>
              <b-button v-if="!selectedEvent.isUserParticipant" @click="registerFromEvent" squared variant="success"> Mitspielen</b-button>
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="modalfooter">
            <h3> Weitere Informationen</h3>
            <p>Alle benötigten Sportgegenstände werden von dem Ersteller gestellt. Benötigt werden Sportsachen und Abriebsfeste Schuhe, falls in der Halle gespielt wird.</p>
          </div>
        </template>
    </b-modal>
  </section>
</template>

<script>

import {eventService} from "@/services/event.service";
import {sportService} from "@/services/sports.service";
import {utilsService} from "@/services/utils.service";

export default {
  name: 'Events',
  components: {
  },
  data() {
    return {
      events: [],
      sports: [],
      hover: [],
      currentPage: 1,
      limit: 5,
      rows: 0,
      selectedEvent: null,
      showCategories: false,
      showSort: false,
      filter: {
        minRating: 3,
        sportIdArray: [],
        fromDate: "",
        toDate: "",
        maxDistance: 0,
        priceMin: 0,
        priceMax: 0,
        stateArray: [4]
      },
      rerendertrigger: 0
    }
  },
  created() {
    this.getEvents();
    this.getSports();
    setTimeout(this.updateTime, 1);
  },
  watch: {
    showCategories(val) {
      let d = document.getElementById('categorieDisplay');
      if (val === true) {
        d.style.maxHeight = null;
      } else {
        d.style.maxHeight = (10 + d.scrollHeight) + "px";
        d.style.height = (10 + d.scrollHeight) + "px";
      }
    }
  },
  methods: {
    updateTime() {
      this.rerendertrigger += 1
      setTimeout(this.updateTime, 1000);
    },
    currencyFormatDE(num) {
      return (
          num
              .toFixed(2)
              .replace('.', ',')
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      )
    },
    unregisterFromEvent() {
      eventService.participateEvent(this.selectedEvent.id, false).then(res => {
        if (res.code === 1) {
          this.$root.$bvToast.toast("Erfolgreich von dem Event abgemeldet", {
            title: "Erfolgreich Abgemeldet",
            autoHideDelay: 5000,
            variant: "success"
          });

          this.selectedEvent.participants.current -= 1
          this.selectedEvent.isUserParticipant = false
          this.getEvents();
        } else {
          this.$root.$bvToast.toast("Es gab einen Fehler beim Abmelden", {
            title: "Fehler beim Abmelden",
            autoHideDelay: 5000,
            variant: "danger"
          });
        }
      })
    },
    registerFromEvent() {
      eventService.participateEvent(this.selectedEvent.id, true).then(res => {
        if (res.code === 1) {
          this.$root.$bvToast.toast("Erfolgreich an dem Event teilgenommen", {
            title: "Erfolgreich Teilgenommen",
            autoHideDelay: 5000,
            variant: "success"
          });
          this.selectedEvent.participants.current += 1
          this.selectedEvent.isUserParticipant = true
          this.getEvents();
        } else {
          this.$root.$bvToast.toast("Es gab einen Fehler beim Anmelden", {
            title: "Fehler beim Anmelden",
            autoHideDelay: 5000,
            variant: "danger"
          });
        }
      })
    },
    displayEvent(event) {
      this.selectedEvent = event
      this.$bvModal.show('single-event-view')
    },
    selectSportFilter(sportId) {
      let index = this.filter.sportIdArray.indexOf(sportId)
      if (index >= 0) {
        this.filter.sportIdArray.splice(index,1)
      } else {
        this.filter.sportIdArray.push(sportId)
      }
      this.getEvents()
    },
    getEvents() {
      eventService.getEventsNew(this.limit, this.currentPage - 1, this.filter).then(res => {
        this.events = res.items;
        this.rows = res.itemCount;
      });
    },
    getSports() {
      sportService.getSports().then(res => {
        this.sports = res.items;
      });
    },
    hovered(index) {
      console.log(index);
      this.hover[index] = true;
    },
    getFooterText(event) {
      const participants = event.participants;
      return `Anmeldungen: ${participants.current}/${participants.max} (Min. ${participants.min})`;
    },
    getFooterClass(index) {
      const participants = this.events[index].participants;
      if (participants.current < participants.min) {
        return "text-warning"
      } else if (participants.current === participants.max) {
        return "text-danger";
      }
      return "text-success"
    },
    formatDate(event) {
      let dateText = "";
      // need replace for backend date, because of mobile issues
      const date = new Date(event.timeStart.replace(/-/g, '/'));
      const untilDate = new Date(date.getTime() + event.duration.time * utilsService.getValueForTimeUnit(event.duration.unit));
      const startDateText = utilsService.getGermanDateText(date);
      if (utilsService.datesAreOnSameDay(date, untilDate)) {
        dateText = `${startDateText} (${utilsService.getGermanDateTextTime(date)} - ${utilsService.getGermanDateTextTime(untilDate)})`;
      } else {
        dateText = `${startDateText} ${utilsService.getGermanDateTextTime(date)} - ${utilsService.getGermanDateText(untilDate)} ${utilsService.getGermanDateTextTime(untilDate)}`;
      }
      return dateText;

    },
    getPrice(event) {
      const total = event.total.value;
      const max = event.maxPricePerPerson.value;
      let current;
      if (event.participants.current !== event.participants.max) {
        current = total / (event.participants.current + 1);
      } else {
        current = total / (event.participants.current);
      }
      if (current > max) {
        current = max;
      }
      return utilsService.formatCurrency(current) + " (Max. " + utilsService.formatCurrency(max) + ")";
    },
    getCurrentTimeLeft(event) {
      let t = Date.parse(event.endTime) - Date.parse(new Date());
      let seconds = Math.floor((t / 1000) % 60);
      let minutes = Math.floor((t / 1000 / 60) % 60);
      let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      let days = Math.floor(t / (1000 * 60 * 60 * 24));
      if (t > 0) {
        let result = "Noch "
        if (days > 0) result += days + " Tage "
        if (hours > 0) result += hours + " Stunden "
        if (minutes > 0) result += minutes + " Minuten "
        if (seconds > 0) result += seconds + " Sekunden "
        return result
      } else {
        return ""
      }
    }
  }
}
</script>

<style scoped>

.header-img {
  min-height: 200px;
  background-attachment: scroll;
}

.search-bar-full-width {
  grid-column: span 2;
}

.header .container {
  padding: 10px 30px;
}

/*-------Event-------*/
.event {
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid grey;
  cursor: pointer;
  margin: 8px 0;
  min-height: 120px;
  overflow: hidden;
}

.event.user-participant {
  border-color: #1c7430;
}

.event:hover {
  background: #eef7fa;
  box-shadow: 0 1px 1px #cfcac4;
}

.eventpic {
  flex: 0 0 130px;
  text-align: center;
  border-right: 1px solid #ebebeb;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.eventpic .picture {
  z-index: 1;
  width: 100%;
  height: 100%;
}

.eventpic .picture img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.eventdetailshort {
  flex: 1;
  min-height: 120px;
  line-height: 1.7;
  font-size: 15px;
  padding: 8px 0 0 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.eventdetailshort > h5 > span, .eventdetailshort > h6 > span {
  float:right;
  margin: 0 20px;
  font-size: 0.8em;
  padding: 5px;
  border-radius: 10px;
}

.eventdetailshort > h5 > span {
  color: green;
  font-weight: 700;
}

.eventdetailshort > h6 > span.align-left {
  float: left;
  margin: 10px 0;
  padding: 0;
}

.eventdetailshort > h6 > span.align-left.no-margin {
  margin: 0;
}

.eventdetailshort > h6 > span.align-left.event-active {
  color: green;
}

.eventdetailshort > h6 > span.align-right {
  float: right;
  text-align: right;
}

h3, h5, h6 {
  color: #696969;
  margin: 0;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/*-------Search und sort -------*/
.searchandsort {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
}

.search input[type="text"], .search button {
  margin: unset;
  border: 0;
  border-radius: 0;
  box-shadow: unset;
}

.search {
  flex: 1 1 auto;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
}

/*-------Sortieren-------*/
.sortbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: all 0.3s ease-in;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 20px;
}

.sortbox label {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin-right: 10px;
}

.sort {
  display: flex;
  padding: 8px 18px;
  border: 1px solid #e9e9e9;
  border-radius: 2px;
  position: relative;
  transition: all 0.5s ease-in;
}

.sort .po {
  display: none;
  height: 15px;
  width: 15px;
}

#sort {
  opacity: 1;
  visibility: visible;
}

#sort .list .item {
  font-size: unset;
}

/*------- Filter -------*/
.filterbox {
  display: block;
  padding: 0 10px;
  width: 100%;
  float: left;
  position: relative;
  height: auto;
}

.filterbox .categories {
  overflow: hidden;
  max-height: 0;
  list-style-type: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease-in-out;
}

.card-filter {
  margin-bottom: 24px;
}

.filterbox .categories li {
  border-bottom: 1px solid #eee;
  padding: 10px;
  cursor: pointer;
  text-align: center;
}


.filterbox .categories li.selected {
  background-color: #1c7430;
}

.filterbox .categories li img {
  width: 32px;
  float: left;
}

.accordion {
  color: black;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 15px;
  border-radius: 2px;
  border: 1px solid #f1f1f1;
}

.accordion:after {
  content: '\002B';
  color: black;
  font-weight: bold;
  float: right;
  margin-left: 5px;
}

.accordion.active:after {
  content: '\2212';

}

.kactive, .collapsible:hover {
  background-color: #f1f1f1;
}

.categories li:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2)
}

.difficulty {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.difficulty .difficulybutton {
  display: flex;
  width: 20%;
  padding: 10px;
  border: 1px solid #e9e9e9;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
}

/*-------Modal-------*/

.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  /* display: flex;*/
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: background-color 0.25s ease;
  z-index: 1746;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal .modalbox {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  transform: scale(1);
  position: relative;
  width: 70%;
  padding: 2.5rem;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.5);
}

.modal .modalimportantinfos {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.modal .modalimportantinfos .modalgallery {
  flex: 35%;
  width: 100%;
  min-height: 300px;
  height: 20vw;
}

.modal .modalimportantinfos .modalgallery img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal .modalimportantinfos .modalcontent {
  margin: 0 20px;
  flex: 65%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #28a745;
}

.modal .modalimportantinfos .modalcontent h1, .modal .modalimportantinfos .modalcontent h2, .modaltext h4, .modaltext p {
  margin: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal .modalimportantinfos .modalcontent .modaltext {
  line-height: 1.5rem;
  margin-top: 10px;
}

.modalformrating {
  margin: 20px 0;
}

.modal .modalimportantinfos .modalcontent .modaltext .modalul {
  margin-bottom: 10px;
}

.modal .modalimportantinfos .modalcontent .modaltext .modalul td {
  padding-left: 20px;
  padding-top: 10px;
}

.modal .modalimportantinfos .modalcontent .modaltext .modalul td:nth-child(2n+1) {
  text-align: right;
}

.modal .modalimportantinfos .modalcontent .acceptplay .acceptplaybutton {
  width: unset;
  margin: 0;
  background: #28a745;
  color: white;
  font-size: 20px;
}

.modal .modalimportantinfos .modalcontent .acceptplay .declineplaybutton {
  width: unset;
  margin: 0;
  background: #fd1339;
  color: white;
  font-size: 20px;
}

.modal .modalimportantinfos .modalcontent .acceptplay {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: stretch;
  margin: 20px 0 0 0;
}

.modal .modalfooter {
  margin: 10px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/*
.modal .modalfooter > p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
*/

.modal .modalbox .close {
  position: absolute;
  top: 20px;
  right: 30px;
  background-color: transparent;
  font-size: 1.5rem;
}

.modal .modalbox .close:before, .modal .modalbox .close:after {
  position: absolute;
  content: '';
  width: 1.25rem;
  height: 0.125rem;
  background-color: black;
}

.modal .modalbox .close:before {
  transform: rotate(-45deg);
}

.modal .modalbox .close:after {
  transform: rotate(45deg);
}


@media screen and (max-width: 768px) {
  .sortbox label {
    display: none;
  }

  .sort {
    width: 50px;
    justify-content: center;
  }

  .sort span {
    display: none;
  }

  .sort .po {
    display: inline-block;
  }

  .modal .modalbox {
    width: 90%;
  }

  .modal .modalbox .modalimportantinfos {
    flex-direction: column;
  }

  .modal .modalbox .modalcontent {
    margin: 0;
  }

  .modal .modalbox .modalgallery {
    height: 20vh;
    min-height: unset;
  }
  .container {
    padding-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding-right: 0;
    padding-left: 0;
  }

  div[class^="col-"], .events {
    padding-left: 0;
    padding-right: 0;
  }
  h5, h6 {
    font-size: inherit;
  }
}
</style>
